export enum ItemType {
  CARD = "CARD",
  DAMAGE_WAIVER = "DAMAGE_WAIVER",
  DONATION = "DONATION",
  GIFT_CARD = "GIFT_CARD",
  GUEST_PRIVS = "GUEST_PRIVS",
  MEMBERSHIP = "MEMBERSHIP",
  PAID_CLASS = "PAID_CLASS",
  PRODUCT = "PRODUCT",
}
